const initialState = {
  loading: false,
  data: [],
  total: 0,
  error: null,
  financePartner: null,
};

export const financePartnersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_FINANCE_PARTNER_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        data: [],
        error: null,
      };
    case "GET_FINANCE_PARTNER_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload.data || [],
        total: action.payload.total || 0,
        error: null,
      };
    case "GET_FINANCE_PARTNER_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: [],
      };

    case "GET_FINANCE_PARTNER_REQUEST":
      return {
        ...state,
        loading: true,
        financePartner: null,
        error: null,
      };
    case "GET_FINANCE_PARTNER_SUCCESS":
      return {
        ...state,
        loading: false,
        financePartner: action.payload,
        error: null,
      };
    case "GET_FINANCE_PARTNER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
